import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-idle-logout-dialog',
  templateUrl: './idle-logout-dialog.component.html',
  styleUrls: ['./idle-logout-dialog.component.scss'],
  imports: [MatIcon],
  standalone: true
})
export class IdleLogoutDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<IdleLogoutDialogComponent>) {}

  ngOnInit(): void {}
}
